export const NAME = 'foldingMachines';